var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2127_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2127_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0498 17C42.6836 27 57.0498 33 57.0498 44.4C57.0498 45.9913 56.1595 47.5174 54.5746 48.6426C52.9898 49.7679 50.8404 50.4 48.5991 50.4C46.3578 50.4 44.2084 49.7679 42.6236 48.6426C41.0387 47.5174 40.1484 45.9913 40.1484 44.4C40.1484 44.2939 40.089 44.1922 39.9834 44.1172C39.8777 44.0421 39.7344 44 39.585 44C39.4356 44 39.2923 44.0421 39.1866 44.1172C39.081 44.1922 39.0216 44.2939 39.0216 44.4C39.0216 52.4 41.8385 53 44.3737 57H29.7259C32.2611 53 35.078 52.4 35.078 44.4C35.078 44.2939 35.0186 44.1922 34.913 44.1172C34.8073 44.0421 34.664 44 34.5146 44C34.3652 44 34.2219 44.0421 34.1162 44.1172C34.0106 44.1922 33.9512 44.2939 33.9512 44.4C33.9512 45.9913 33.0609 47.5174 31.4761 48.6426C29.8912 49.7679 27.7418 50.4 25.5005 50.4C23.2592 50.4 21.1098 49.7679 19.525 48.6426C17.9401 47.5174 17.0498 45.9913 17.0498 44.4C17.0498 33 31.416 27 37.0498 17Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2127_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.491 152.342C126.434 149.56 128.811 135.994 139.376 135.994C149.941 135.994 151.262 145.386 151.262 152.342C151.262 166.255 127.491 179.125 127.491 199.994H151.262V188.864",
    stroke: "black",
    strokeWidth: 9,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2127_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.262 127.484L96.9406 208.989",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.2 135.021C82.2065 136.115 82.2065 136.115 82.2131 137.231C82.2546 144.105 82.3012 150.979 82.3533 157.852C82.38 161.386 82.4047 164.92 82.425 168.454C82.4447 171.864 82.4694 175.275 82.4976 178.685C82.5075 179.986 82.5156 181.287 82.5218 182.588C82.5308 184.411 82.5463 186.233 82.5633 188.056C82.5704 189.093 82.5775 190.131 82.5848 191.199C82.7299 193.8 82.9058 195.303 83.8 197.428C85.4224 198.58 85.4224 198.58 87 199.211C87 199.8 87 200.388 87 200.994C81.896 200.994 76.792 200.994 71.5333 200.994C71.5333 200.406 71.5333 199.818 71.5333 199.211C73.9093 198.329 73.9093 198.329 76.3333 197.428C76.358 190.849 76.377 184.269 76.3886 177.69C76.3942 174.634 76.4017 171.579 76.4138 168.524C76.4276 165.012 76.4328 161.501 76.4375 157.989C76.443 156.891 76.4485 155.793 76.4542 154.662C76.4543 153.136 76.4543 153.136 76.4544 151.58C76.4568 150.683 76.4592 149.786 76.4616 148.862C76.428 146.391 76.428 146.391 75.2667 143.937C74.0347 144.231 72.8027 144.525 71.5333 144.828C71.3573 143.945 71.1813 143.063 71 142.153C72.3635 140.954 73.7303 139.767 75.1 138.587C75.4847 138.247 75.8693 137.907 76.2656 137.557C76.642 137.235 77.0184 136.913 77.4063 136.581C77.7498 136.283 78.0933 135.984 78.4473 135.676C79.7473 134.892 80.8272 134.977 82.2 135.021Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2127_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.95 319C181.316 309 166.95 303 166.95 291.6C166.95 290.009 167.841 288.483 169.425 287.357C171.01 286.232 173.16 285.6 175.401 285.6C177.642 285.6 179.792 286.232 181.376 287.357C182.961 288.483 183.852 290.009 183.852 291.6C183.852 291.706 183.911 291.808 184.017 291.883C184.122 291.958 184.266 292 184.415 292C184.564 292 184.708 291.958 184.813 291.883C184.919 291.808 184.978 291.706 184.978 291.6C184.978 283.6 182.161 283 179.626 279H194.274C191.739 283 188.922 283.6 188.922 291.6C188.922 291.706 188.981 291.808 189.087 291.883C189.193 291.958 189.336 292 189.485 292C189.635 292 189.778 291.958 189.884 291.883C189.989 291.808 190.049 291.706 190.049 291.6C190.049 290.009 190.939 288.483 192.524 287.357C194.109 286.232 196.258 285.6 198.499 285.6C200.741 285.6 202.89 286.232 204.475 287.357C206.06 288.483 206.95 290.009 206.95 291.6C206.95 303 192.584 309 186.95 319Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2127_347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2127_347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2127_347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 74,
    fill: "white",
    transform: "matrix(-1 0 0 -1 156.262 204.994)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2127_347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.262,
    height: 93.9887,
    fill: "white",
    transform: "matrix(-1 0 0 -1 121.262 214.989)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2127_347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "matrix(-1 0 0 -1 207 319)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfS);
export default __webpack_public_path__ + "static/media/HalfS.254b685e01b6d7f96fb67c46c3745e84.svg";
export { ForwardRef as ReactComponent };